import { render } from "./IconSliderArrow.vue?vue&type=template&id=369deb34"
import script from "./IconSliderArrow.vue?vue&type=script&lang=js"
export * from "./IconSliderArrow.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__